var _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMutualfund(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#EEEEEF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5182_2039",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H23V23H6V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5182_2039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 18.2088H6.72397C6.46326 18.2088 6.25 18.4221 6.25 18.6827V19.1256C6.25 19.3863 6.46326 19.5996 6.72397 19.5996H9.99999C10.2607 19.5996 10.474 19.3863 10.474 19.1256V18.6827C10.474 18.4221 10.2607 18.2088 9.99999 18.2088Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99975 19.5994H6.72373C6.46302 19.5994 6.24976 19.8127 6.24976 20.0734V20.5163C6.24976 20.7769 6.46302 20.9902 6.72373 20.9902H9.99975C10.2605 20.9902 10.4737 20.7769 10.4737 20.5163V20.0734C10.4737 19.8127 10.2605 19.5994 9.99975 19.5994Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 20.99H6.72349C6.46278 20.99 6.24951 21.2033 6.24951 21.464V21.9069C6.24951 22.1676 6.46278 22.3809 6.72349 22.3809H9.99951C10.2602 22.3809 10.4735 22.1676 10.4735 21.9069V21.464C10.4735 21.2033 10.2602 20.99 9.99951 20.99Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1382 16.8172H12.8622C12.6014 16.8172 12.3882 17.0305 12.3882 17.2911V17.734C12.3882 17.9947 12.6014 18.208 12.8622 18.208H16.1382C16.3989 18.208 16.6121 17.9947 16.6121 17.734V17.2911C16.6121 17.0305 16.3989 16.8172 16.1382 16.8172Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1382 18.2088H12.8622C12.6014 18.2088 12.3882 18.4221 12.3882 18.6827V19.1256C12.3882 19.3863 12.6014 19.5996 12.8622 19.5996H16.1382C16.3989 19.5996 16.6121 19.3863 16.6121 19.1256V18.6827C16.6121 18.4221 16.3989 18.2088 16.1382 18.2088Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1382 14.0359H12.8622C12.6014 14.0359 12.3882 14.2492 12.3882 14.5099V14.9528C12.3882 15.2135 12.6014 15.4268 12.8622 15.4268H16.1382C16.3989 15.4268 16.6121 15.2135 16.6121 14.9528V14.5099C16.6121 14.2492 16.3989 14.0359 16.1382 14.0359Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1382 15.4265H12.8622C12.6014 15.4265 12.3882 15.6398 12.3882 15.9005V16.3434C12.3882 16.6041 12.6014 16.8174 12.8622 16.8174H16.1382C16.3989 16.8174 16.6121 16.6041 16.6121 16.3434V15.9005C16.6121 15.6398 16.3989 15.4265 16.1382 15.4265Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1382 19.5994H12.8622C12.6014 19.5994 12.3882 19.8127 12.3882 20.0734V20.5163C12.3882 20.7769 12.6014 20.9902 12.8622 20.9902H16.1382C16.3989 20.9902 16.6121 20.7769 16.6121 20.5163V20.0734C16.6121 19.8127 16.3989 19.5994 16.1382 19.5994Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1382 20.99H12.8622C12.6014 20.99 12.3882 21.2033 12.3882 21.464V21.9069C12.3882 22.1676 12.6014 22.3809 12.8622 22.3809H16.1382C16.3989 22.3809 16.6121 22.1676 16.6121 21.9069V21.464C16.6121 21.2033 16.3989 20.99 16.1382 20.99Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2768 16.8172H19.0008C18.7401 16.8172 18.5269 17.0305 18.5269 17.2911V17.734C18.5269 17.9947 18.7401 18.208 19.0008 18.208H22.2768C22.5376 18.208 22.7508 17.9947 22.7508 17.734V17.2911C22.7508 17.0305 22.5376 16.8172 22.2768 16.8172Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2768 18.2088H19.0008C18.7401 18.2088 18.5269 18.4221 18.5269 18.6827V19.1256C18.5269 19.3863 18.7401 19.5996 19.0008 19.5996H22.2768C22.5376 19.5996 22.7508 19.3863 22.7508 19.1256V18.6827C22.7508 18.4221 22.5376 18.2088 22.2768 18.2088Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2766 19.5994H19.0006C18.7399 19.5994 18.5266 19.8127 18.5266 20.0734V20.5163C18.5266 20.7769 18.7399 20.9902 19.0006 20.9902H22.2766C22.5373 20.9902 22.7506 20.7769 22.7506 20.5163V20.0734C22.7506 19.8127 22.5373 19.5994 22.2766 19.5994Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2768 11.2537H19.0008C18.7401 11.2537 18.5269 11.467 18.5269 11.7277V12.1706C18.5269 12.4312 18.7401 12.6445 19.0008 12.6445H22.2768C22.5376 12.6445 22.7508 12.4312 22.7508 12.1706V11.7277C22.7508 11.467 22.5376 11.2537 22.2768 11.2537Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2768 12.6453H19.0008C18.7401 12.6453 18.5269 12.8586 18.5269 13.1193V13.5622C18.5269 13.8228 18.7401 14.0361 19.0008 14.0361H22.2768C22.5376 14.0361 22.7508 13.8228 22.7508 13.5622V13.1193C22.7508 12.8586 22.5376 12.6453 22.2768 12.6453Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2766 14.0359H19.0006C18.7399 14.0359 18.5266 14.2492 18.5266 14.5099V14.9528C18.5266 15.2135 18.7399 15.4268 19.0006 15.4268H22.2766C22.5373 15.4268 22.7506 15.2135 22.7506 14.9528V14.5099C22.7506 14.2492 22.5373 14.0359 22.2766 14.0359Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2766 15.4265H19.0006C18.7399 15.4265 18.5266 15.6398 18.5266 15.9005V16.3434C18.5266 16.6041 18.7399 16.8174 19.0006 16.8174H22.2766C22.5373 16.8174 22.7506 16.6041 22.7506 16.3434V15.9005C22.7506 15.6398 22.5373 15.4265 22.2766 15.4265Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9206 7.76748L8.36182 14.0312",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6276 8.65408L21.9 6.83568C21.9651 6.74261 21.896 6.61514 21.7825 6.6189L19.5644 6.69204C19.462 6.6954 19.3989 6.8054 19.4477 6.89548L20.3935 8.64073C20.4423 8.73081 20.5689 8.73802 20.6276 8.65408Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78093 16.8172H6.72397C6.46326 16.8172 6.25 17.0305 6.25 17.2911V17.734C6.25 17.9947 6.46326 18.208 6.72397 18.208H9.99999C10.2607 18.208 10.474 17.9947 10.474 17.734V17.2911C10.474 17.0305 10.2607 16.8172 9.99999 16.8172H8.94304",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2197 22.3809H22.2766C22.5373 22.3809 22.7506 22.1676 22.7506 21.9069V21.464C22.7506 21.2033 22.5373 20.99 22.2766 20.99H19.0006C18.7399 20.99 18.5266 21.2033 18.5266 21.464V21.9069C18.5266 22.1676 18.7399 22.3809 19.0006 22.3809H20.0575",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutualfund);
export default __webpack_public_path__ + "static/media/mutualfund.e4330b9685f2db8bc221397e4e4e8427.svg";
export { ForwardRef as ReactComponent };